import Icon from '../components/Icon.vue'

Icon.register({
  fax: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M64 128c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-320c0-17.7 14.3-32 32-32h32zM480 160c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32h-320c-17.7 0-32-14.3-32-32v-448c0-17.7 14.3-32 32-32h242.7c8.5 0 16.6 3.4 22.6 9.4l45.3 45.3c6 6 9.4 14.1 9.4 22.6v82.8zM288 432v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM288 304v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM416 432v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM416 304v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM432 192v-96h-32c-8.8 0-16-7.2-16-16v-32h-208v144h256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fax.js
// module id = 1322
// module chunks = 0